import { Bale } from '../types';
import { isFileDuplicated } from './files/isFileDuplicated';

export const isBaleDuplicated = async (bales: Bale[], bale: Bale) => {
  const files = bales.map((b) => b.photo);

  return await isFileDuplicated(files, bale.photo);
};
